import React, { useContext, useEffect, useState, useCallback } from "react";
import { Divider } from "@mui/material";
import CustomLabel from "../../components/common/customLabel";
import useSetTitlePage from "../../hooks/useSetTitlePage";
import Novedades from "../../components/home/novedades/novedades";
import Atajos from "../../components/home/atajos/atajos";
import {
  labelTitlePrestador,
  labelNombreAfiliadoHome,
  labelNovedadesHome,
  labelAtajosHome,
} from "../../global/styles";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import * as apiService from "../../../api";
import Popup from "../../components/popUp/popUp";
import { ConfigurationContext } from "../../context/configurationContext";

const Home = () => {
  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);
  const { getAlertaPersonalizada } = useContext(ConfigurationContext);
  const [listaSlider, setListaSlider] = useState([]);
  const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado);

  const getAllDashboardSlider = useCallback(async () => {
    try {
      const response = await apiService.ajustes.getAllDashboardSlider();
      setListaSlider(response.data.result);
    } catch (err) {
      console.error("Error fetching dashboard slider:", err);
    }
  }, []);

  const titleHome = (
    <>
      <CustomLabel style={{ ...labelTitlePrestador }}>
        Hola,{" "}
        <label style={{ ...labelNombreAfiliadoHome }}>
          {infoAfiliado.nombres} {infoAfiliado.apellidos}
        </label>
      </CustomLabel>
      <Divider />
    </>
  );

  useSetTitlePage(titleHome);

  useEffect(() => {
    const userIsInactive = () => {
      const isAuthenticated = localStorage.getItem("autenticado") === "true";
      if (!isAuthenticated) {
        navigate("/login");
      } else {
        setIsReady(true);
      }
    };

    userIsInactive();
  }, []);

  useEffect(() => {
    if (isReady) {
      getAllDashboardSlider();
      getAlertaPersonalizada();
    }
  }, [isReady]);

  if (!isReady) {
    return null;
  }

  return (
    <>
      <CustomLabel style={{ ...labelNovedadesHome }}>Novedades</CustomLabel>
      <Novedades items={listaSlider} />
      <CustomLabel style={{ ...labelAtajosHome }}>Atajos</CustomLabel>
      <Atajos />
      <Popup />
    </>
  );
};

export default Home;
